<div class="sidebar d-flex flex-column h-100">
  <!-- Company selector -->
  <div class="sidebar-company-selector px-2 py-2">
    @if (isLoadingCompany) {
      <div class="d-flex align-items-center gap-2 px-2 py-1">
        <mat-spinner diameter="18"></mat-spinner>
        <span class="text-muted small">Loading...</span>
      </div>
    } @else if (companyId && company) {
      <a
        [routerLink]="['/', 'companies']"
        class="company-selector-link d-flex align-items-center gap-2"
      >
        <mat-icon fontSet="material-symbols-outlined">business</mat-icon>
        <span class="company-name text-truncate">{{ company.name }}</span>
        <mat-icon
          fontSet="material-symbols-outlined"
          class="ms-auto chevron-icon"
          >unfold_more</mat-icon
        >
      </a>
    } @else {
      <a
        [routerLink]="['/', 'companies']"
        class="company-selector-link d-flex align-items-center gap-2 text-muted"
      >
        <mat-icon fontSet="material-symbols-outlined">business</mat-icon>
        <span class="company-name">Select company</span>
        <mat-icon
          fontSet="material-symbols-outlined"
          class="ms-auto chevron-icon"
          >unfold_more</mat-icon
        >
      </a>
    }
  </div>

  <!-- Navigation -->
  <nav class="sidebar-nav flex-grow-1 overflow-y-auto py-1">
    @if (companyId) {
      <!-- PROJECTS -->
      <div
        class="nav-section-header px-3 d-flex align-items-center justify-content-between"
      >
        <a
          [routerLink]="['/', companyId, 'projects', 'list']"
          (click)="clickOnVoice.emit()"
          class="nav-section-label-link"
          >Projects</a
        >
        <a
          [routerLink]="['/', companyId, 'projects', 'new']"
          class="nav-section-action"
          title="New Project"
        >
          <mat-icon fontSet="material-symbols-outlined">add</mat-icon>
        </a>
      </div>

      @for (project of projects.slice(0, projectsLimit); track project.id) {
        <div
          routerLinkActive="active"
          class="nav-item-project-wrapper d-flex align-items-center"
        >
          <a
            [routerLink]="['/', companyId, project.id, 'dashboard']"
            (click)="clickOnVoice.emit()"
            class="nav-item-project-link d-flex align-items-center gap-2 flex-grow-1 text-truncate"
          >
            <mat-icon
              fontSet="material-symbols-outlined"
              class="nav-item-project-dot flex-shrink-0"
              >folder</mat-icon
            >
            <span class="text-truncate">{{ project.title }}</span>
          </a>
          <button
            class="nav-item-project-menu-btn"
            [matMenuTriggerFor]="projectMenu"
            (click)="$event.stopPropagation()"
            title="Project options"
          >
            <mat-icon fontSet="material-symbols-outlined">more_vert</mat-icon>
          </button>
          <mat-menu #projectMenu="matMenu">
            <a
              mat-menu-item
              [routerLink]="['/', companyId, project.id, 'dashboard']"
            >
              <mat-icon fontSet="material-symbols-outlined">dashboard</mat-icon>
              <span>Dashboard</span>
            </a>
            <a
              mat-menu-item
              [routerLink]="['/', companyId, project.id, 'tasks', 'list']"
            >
              <mat-icon fontSet="material-symbols-outlined">list_alt</mat-icon>
              <span>Tasks</span>
            </a>
            @if (featureAccess.isAllowed('gantt')) {
            <a
              mat-menu-item
              [routerLink]="['/', companyId, project.id, 'tasks', 'timeline']"
            >
              <mat-icon fontSet="material-symbols-outlined"
                >view_timeline</mat-icon
              >
              <span>Timeline</span>
            </a>
            }
            <a
              mat-menu-item
              [routerLink]="['/', companyId, project.id, 'board']"
            >
              <mat-icon fontSet="material-symbols-outlined">view_kanban</mat-icon>
              <span>Board</span>
            </a>
            <a
              mat-menu-item
              [routerLink]="['/', companyId, project.id, 'sprints']"
            >
              <mat-icon fontSet="material-symbols-outlined">sprint</mat-icon>
              <span>Sprints</span>
            </a>
            <a
              mat-menu-item
              [routerLink]="['/', companyId, project.id, 'backlog']"
            >
              <mat-icon fontSet="material-symbols-outlined">inventory_2</mat-icon>
              <span>Backlog</span>
            </a>
            <a
              mat-menu-item
              [routerLink]="[
                '/',
                companyId,
                'projects',
                project.id,
                'settings',
              ]"
            >
              <mat-icon fontSet="material-symbols-outlined">settings</mat-icon>
              <span>Settings</span>
            </a>
          </mat-menu>
        </div>
      }

      @if (isLoadingProjects) {
        <div class="px-3 py-1">
          <mat-spinner diameter="14"></mat-spinner>
        </div>
      }

      @if (projects.length > projectsLimit) {
        <a
          [routerLink]="['/', companyId, 'projects', 'list']"
          class="nav-see-more px-3"
        >
          See all projects ({{ projects.length }})
        </a>
      }

      <mat-divider class="my-2"></mat-divider>

      <!-- COMPANY -->
      <div class="nav-section-label px-3 py-1">Company</div>

      <a
        [routerLink]="['/', companyId, 'daily-resume']"
        routerLinkActive="active"
        (click)="clickOnVoice.emit()"
        class="nav-item d-flex align-items-center gap-2 px-3 py-2"
      >
        <mat-icon fontSet="material-symbols-outlined">today</mat-icon>
        <span>Daily Resume</span>
      </a>

      <a
        [routerLink]="['/', companyId, 'notes']"
        routerLinkActive="active"
        (click)="clickOnVoice.emit()"
        class="nav-item d-flex align-items-center gap-2 px-3 py-2"
      >
        <mat-icon fontSet="material-symbols-outlined">psychology</mat-icon>
        <span>Notes</span>
      </a>

      <a
        [routerLink]="['/', companyId, 'users', 'list']"
        routerLinkActive="active"
        (click)="clickOnVoice.emit()"
        class="nav-item d-flex align-items-center gap-2 px-3 py-2"
      >
        <mat-icon fontSet="material-symbols-outlined">group</mat-icon>
        <span>Users</span>
      </a>

      <a
        [routerLink]="['/', 'company', companyId, 'team', 'list']"
        routerLinkActive="active"
        (click)="clickOnVoice.emit()"
        class="nav-item d-flex align-items-center gap-2 px-3 py-2"
      >
        <mat-icon fontSet="material-symbols-outlined">people</mat-icon>
        <span>Teams</span>
      </a>

      <a
        [routerLink]="['/', companyId, 'ticket-widgets']"
        routerLinkActive="active"
        (click)="clickOnVoice.emit()"
        class="nav-item d-flex align-items-center gap-2 px-3 py-2"
      >
        <mat-icon fontSet="material-symbols-outlined">support_agent</mat-icon>
        <span>Ticket Widgets</span>
      </a>

      <mat-divider class="my-2"></mat-divider>
    }

    <!-- INTEGRATIONS -->
    <div class="nav-section-label px-3 py-1">Integrations</div>

    <a
      [routerLink]="['/', 'profile', 'integrations']"
      routerLinkActive="active"
      (click)="clickOnVoice.emit()"
      class="nav-item d-flex align-items-center gap-2 px-3 py-2"
    >
      <mat-icon fontSet="material-symbols-outlined">extension</mat-icon>
      <span>Integrations</span>
    </a>

    <mat-divider class="my-2"></mat-divider>

    <!-- NOTIFICATIONS -->
    <a
      [routerLink]="['/', 'notifications', 'history']"
      routerLinkActive="active"
      (click)="clickOnVoice.emit()"
      class="nav-item d-flex align-items-center gap-2 px-3 py-2"
    >
      <mat-icon fontSet="material-symbols-outlined">notifications</mat-icon>
      <span>Notifications</span>
    </a>
  </nav>

  <!-- Footer -->
  @if (auth.user | async; as user) {
    <div class="sidebar-footer d-flex align-items-center gap-2 px-3 pt-2">
      <div
        class="user-avatar flex-shrink-0"
        [style.background-image]="'url(' + user.photoURL + ')'"
        [attr.title]="user.displayName"
      ></div>
      <div class="user-info flex-grow-1 min-width-0">
        <div class="user-name text-truncate">{{ user.displayName }}</div>
        @if (company) {
          <div class="user-company text-truncate">{{ company.name }}</div>
        }
      </div>
      <a
        [routerLink]="['/', 'profile']"
        (click)="clickOnVoice.emit()"
        class="footer-icon-btn"
        title="Settings"
      >
        <mat-icon fontSet="material-symbols-outlined">settings</mat-icon>
      </a>
      <a
        [routerLink]="['/', 'auth', 'logout']"
        (click)="clickOnVoice.emit()"
        class="footer-icon-btn"
        title="Logout"
      >
        <mat-icon fontSet="material-symbols-outlined">logout</mat-icon>
      </a>
    </div>
  } @else {
    <div
      class="sidebar-footer d-flex align-items-center justify-content-center py-2"
    >
      <mat-spinner diameter="20"></mat-spinner>
    </div>
  }

  <app-indicator></app-indicator>
</div>
